import styled from 'styled-components';

const LoadingWrapper = styled.div`
    width: 100%;
    height: 360px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const HighlightText = styled.span`
    color: ${({ theme }) => theme.palette.primary.dark};
    font-weight: bold;
`;

const Description = styled.div`
  display: flex;
`;

export { LoadingWrapper, HighlightText, Description };
